import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {messageWindow} from '../Elements/Snackbar/MessageWindow'
import MessageWindow from '../Elements/Snackbar/MessageWindow'
import {ColorLinearProgress} from '../../src/App'
import {localization} from '../Frames/localization'

import Label from '../Elements/Label/labels'
//Элементы страницы
import {CardLimits, SetLimits} from './ElementsPage/BoxsLimits'

//settings
import {AppliedSettings} from '../../src/App' 

import './limits.css'
import './limitsAdaptive.css'

const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}
class CardLimit extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
            TabNotAvailable: false,

            asyncDisabled: false,
            progress: false,

            key: undefined,
            res: Array, 
            isLoaded: false,
        }
        this.componentDidMount = this.componentDidMount.bind(this)
        this.asyncDisabledTrue = this.asyncDisabledTrue.bind(this)
        this.asyncDisabledFalse= this.asyncDisabledFalse.bind(this)
    }
    asyncDisabledTrue()
    {
        this.setState({asyncDisabled: true, progress: true})
    }
    asyncDisabledFalse()
    {
        this.setState({asyncDisabled: false, progress: false})
    }
    componentDidMount()
    {
        this.props.setSelectedIndex(3)
            fetch(`/api/getlimits`, requestOptionsExit)
            .then((response) => {
                if(response.status == 500)
                {
                    messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                    this.setState({key: Math.random()})
                }
                return response.json()})
            .then((response) => {
                if(response.data == null){
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({key: Math.random(),open: true})
                }
                else
                {
                    this.setState({res: response, isLoaded: true});
                }
            })
            .catch((error) => {
                // Handle the error
                this.setState({TabNotAvailable: true})
              })
            this.forceUpdate();
    }
    render() {
        const {isLoaded, res, progress, TabNotAvailable} = this.state;

        return(
            <div>
            {TabNotAvailable == true &&
            <div className="containers">
                <div className="TabNotAvailable">
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label textLabel={localization.GetTranslate('Alert.TabNotAvailable')} className="CashbackLabelNotAvailable"></Label>   
                    </Grid>
                </Grid>
                </div>                
            </div>
            } 
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            } 
            <div className="containers"> 
             <MessageWindow key={this.state.key} ></MessageWindow> 
                {!isLoaded && TabNotAvailable == false &&
                    <div class="preloader"></div> 
                }
                {isLoaded &&
                <Grid container justify="center" spacing={3}>
                    {AppliedSettings.limits_table_view &&
                    <Grid item xs={"auto"}>
                        <CardLimits res={this.state.res}></CardLimits>
                    </Grid>
                    }
                    <Grid item xs={"auto"}>
                        <SetLimits
                        AppliedSettings={AppliedSettings}
                        asyncDisabledTrue={this.asyncDisabledTrue}
                        asyncDisabledFalse={this.asyncDisabledFalse}
                        asyncDisabled={this.state.asyncDisabled}
                        componentDidMount = {this.componentDidMount}
                         res={res}
                         ></SetLimits>
                    </Grid>
                </Grid>   
                }             
            </div>
            </div>
        );

    }
}

export default CardLimit;

